<template>
  <v-form
    lazy-validation
    v-model="valid"
    @submit.prevent="submit"
    ref="form"
  >
      <v-container class="text-center" v-if="localStockItem">
        <v-text-field
          filled
          data-cy="FormStockItem-farm"
          :label="$$t('farm')"
          v-model="localStockItem.deliveryNote.farm.name"
          disabled
        />
        <v-text-field
          filled
          data-cy="FormStockItem-goodsReceivedNumber"
          :label="$$t('goodsReceivedNumber')"
          v-model="localStockItem.deliveryNote.goodsReceivedNumber"
          disabled
        />
        <v-combobox
          data-cy="FormStockItem-sizeRange"
          :items="sizeRanges"
          v-model="localStockItem.sizeRange"
        />
        <v-text-field
          filled
          data-cy="FormStockItem-receivedMass"
          :label="$$t('receivedMass')"
          v-model="localStockItem.receivedMass"
        />
        <v-text-field
          filled
          data-cy="FormStockItem-harvestedMass"
          :label="$$t('harvestedMass')"
          v-model="localStockItem.harvestedMass"
        />
        <v-text-field
          filled
          data-cy="FormStockItem-packedMass"
          :label="$$t('packedMass')"
          v-model="localStockItem.packedMass"
        />
        <v-text-field
          filled
          data-cy="FormStockItem-numberOfAbalone"
          :label="$$t('numberOfAbalone')"
          v-model="localStockItem.quantity"
        />
        <div class="d-flex justify-end mb-6">
          <v-btn color="default" outlined class="ml-4 btn-cancel" @click="cancel"
            data-cy="FormStockItem-button-cancel">
            {{ $t('common.buttons.cancel') }}
          </v-btn>
          <v-btn color="primary" type="submit" class="ml-4" :loading="$parent.isSaving"
            data-cy="FormStockItem-button-save">
              {{ $t('common.buttons.save') }}
            </v-btn>
        </div>
      </v-container>
  </v-form>
</template>

<script>
import product from '../mixins/product';

export default {
  name: 'FormStockItem',
  module: 'StockItem',
  mixins: [product],
  props: {
    /**
    * Set the text box value. Default: undefined,
    */
    StockItem: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      /**
      * Hold form validation state
      */
      valid: false,
      /**
      * Local value used for property localStockItem
      */
      localStockItem: undefined,
    };
  },
  watch: {
    StockItem() {
      this.localStockItem = this.StockItem;
    },
  },
  created() {
    this.localStockItem = this.StockItem;
  },
  methods: {
    /** Submit Form data trigger
     * @event save
     * @type {object}
     */
    submit() {
      // validate
      if (this.$refs.form.validate()) {
        this.$emit('save', this.localStockItem);
      }
    },
    /** Cancel form trigger
     * @event cancel
     */
    cancel() {
      this.$emit('cancel');
    },
  },
};
</script>

<docs>
# FormStockItem example

'''js
<FormStockItem :StockItem="StockItem" />
'''
</docs>
